<template>
  <v-footer color="white">
    <v-container fluid style="max-width:1280px">
      <v-row>
        <v-col class="col-md-4 col-sm-6">
          <v-list dense>
            <div class="font-weight-bold">AREA LEGALE</div>
            <v-list-item-group>
              <v-list-item class="pl-0" href="/privacy-policy" target="_blank">
                <v-list-item-content>
                  <v-list-item-title>PRIVACY</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="pl-0" href="/condizioni-generali-di-vendita" target="_blank">
                <v-list-item-content>
                  <v-list-item-title>CONDIZIONI DI VENDITA</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="pl-0" href="/cookie-policy" target="_blank">
                <v-list-item-content>
                  <v-list-item-title>COOKIE POLICY</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col cols="4"  class="hidden-sm-and-down">
          <v-row>
            <v-col cols="6">
              <a href="https://www.coldiretti.it" target="_blank">
                <v-img height="90" max-width="90" contain src="@/assets/logos/coldiretti.png"
                       alt="coldiretti_logo"
                       class="mx-2"></v-img>
              </a>
            </v-col>
            <v-col cols="6">
              <a href="https://www.campagnamica.it" target="_blank"
                 class="mx-auto">
                <v-img height="90" max-width="90" contain src="@/assets/logos/campagna-amica-mercato.png"
                       alt="terranostra_logo"
                       class="mx-2"></v-img>
              </a>
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-list>
            <v-list-item-group>
              <v-list-item class="pl-0" href="/chi-siamo">
                <v-list-item-content>
                  <v-list-item-title>CHI SIAMO</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-btn icon color="customRaspBerry" href="https://www.facebook.com/mercatocircomassimo/">
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn icon color="customRaspBerry" href="https://twitter.com/campagnaamicacm/">
            <v-icon>mdi-twitter</v-icon>
          </v-btn>
          <v-btn icon color="customRaspBerry" href="https://www.instagram.com/campagna_amica_circomassimo/">
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="customMustard">
        <v-col class="text-center">
          <v-row clas="text-center">
            <v-col cols="12">
                <p>Un’iniziativa di Campagna Amica Servizi srl, con sede legale in Via XXIV Maggio n. 43, Roma, CF. e P.IVA
                  16416751002,
                  indirizzo PEC: <a
                      href="mailto:campagnaamicaservizisrl@legalmail.it" style="color:black">campagnaamicaservizisrl@legalmail.it</a>,
                  indirizzo di supporto: <a href="mailto:mercatonline@campagnamica.it" style="color:black">mercatonline@campagnamica.it</a>,
                  3666570109 - tramite WhatsApp dalle 9 alle 19
                </p>
              </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "Footer.vue",
}
</script>

<style scoped lang="scss">

</style>